import CustomGame from "../CustomGame";

export default ({ navigation }: { navigation: any }) => <CustomGame navigation={navigation} settings={{ wordLength: 8 }} />;